import React from "react";

const Claim = () => <p>Claim, if NFT owner and NFT can mine</p>;

export default Claim;
